import { Component } from 'react';
import MessageUtils from "./MessageUtils";
import i18n from "../i18next";

class TimeValidationUtils extends Component {

    static validateOpeningHours(state, dispatch) {

        for (let i = 0; i < state.length; i++) {

            if (state[i].openHour !== null && state[i].openMinute == null) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.enterMinutes'));
                return false;
            }

            if (state[i].openHour == null && state[i].openMinute !== null) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.enterHour'));
                return false;
            }

            if (state[i].closeHour !== null && state[i].closeMinute == null) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.enterMinutes'));
                return false;
            }

            if (state[i].closeHour == null && state[i].closeMinute !== null) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.enterHour'));
                return false;
            }

            if (state[i].openHour !== null && (state[i].closeHour == null || state[i].closeMinute == null)) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.enterClosingTime'));
                return false;
            }

            if (state[i].closeHour !== null && (state[i].openHour == null || state[i].openMinute == null)) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.enterOpeningTime'));
                return false;
            }

            if ((state[i].openHour !== null && state[i].openHour < 0)
                || (state[i].openMinute !== null && state[i].openMinute < 0)
                || (state[i].closeHour !== null && state[i].closeHour < 0)
                || (state[i].closeMinute !== null && state[i].closeMinute < 0)) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.negativeNumberWarning'));
                return false;
            }

            // Hour Minute Validation Data Format
            if (!this.isInteger(state[i].openHour)) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.incorrectHourData'));
                return false;
            }

            if (!this.isInteger(state[i].closeHour)) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.incorrectHourData'));
                return false;
            }

            if (!this.isInteger(state[i].openMinute)) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.incorrectMinuteData'));
                return false;
            }

            if (!this.isInteger(state[i].closeMinute)) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.incorrectMinuteData'));
                return false;
            }

        }

        return true;

    }

    static validateCutOffTimes(state, dispatch) {

        for (let i = 0; i < state.length; i++) {

            if (state[i].minute !== null && state[i].hour == null) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.enterHour'));
                return false;
            }

            if (state[i].minute == null && state[i].hour !== null) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.enterMinutes'));
                return false;
            }

            if ((state[i].hour !== null && state[i].hour < 0)
                || (state[i].minute !== null && state[i].minute < 0)) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.negativeNumberWarning'));
                return false;
            }

            // Hour Minute Validation Data Format
            if (!this.isInteger(state[i].hour)) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.incorrectHourData'));
                return false;
            }

            if (!this.isInteger(state[i].minute)) {
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:openingHoursActions.incorrectMinuteData'));
                return false;
            }

        }

        return true;

    }

    static isInteger(n) {
        if (Number(n) === n && n % 1 === 0) {
            return true;
        } else if (n === null) {
            return true;
        } else {
            return false;
        }
    }

    static prependZeroToTimeValuesOnCondition(target, itemId, openingHours, serviceSettingsScreen, itemDay) {

        // CutOffTimes
        if (target.name === 'hour' || target.name === 'minute') {
            let updatedCutOffTimes = [];

            openingHours.map((item) => {
                const currentCutOffTime = {
                    day: item.day,
                    hour: item.hour,
                    minute: item.minute
                };

                // If value of the time field is less than 9 and there is no 0 in front of it appended 0
                let hasZero = /^0/.test(target.value);
                let hasCharacters = /\W+/.test(target.value);

                if (currentCutOffTime.day === itemId) {
                    if (target.value >= 0 && target.value <= 9 && target.value !== '' && !hasZero && !hasCharacters) {
                        currentCutOffTime[target.name] = '0' + target.value;
                    }

                    if (hasCharacters) {
                        currentCutOffTime[target.name] = target.value;
                    }
                }

                updatedCutOffTimes.push(currentCutOffTime);
            });

            return updatedCutOffTimes;
        }

        // serviceSettingsScreen Screen
        if (serviceSettingsScreen && (target.name === 'openHour' || target.name === 'closeHour' || target.name === 'openMinute' || target.name === 'closeMinute')) {
            let updatedRestaurantOpeningHours = [];

            openingHours.map((item) => {
                const currentOpeningHours = {
                    id: item.id,
                    day: item.day,
                    openHour: item.openHour,
                    openMinute: item.openMinute,
                    closeHour: item.closeHour,
                    closeMinute: item.closeMinute,
                };

                // If value of the time field is less than 9 and there is no 0 in front of it appended 0
                let hasZero = /^0/.test(target.value);
                let hasCharacters = /\W+/.test(target.value);

                if (currentOpeningHours.day === itemId) {

                    if (target.value >= 0 && target.value <= 9 && target.value !== '' && !hasZero) {
                        currentOpeningHours[target.name] = '0' + target.value;
                    }

                    if (hasCharacters) {
                        currentOpeningHours[target.name] = target.value;
                    }
                }

                updatedRestaurantOpeningHours.push(currentOpeningHours);
            });

            return updatedRestaurantOpeningHours;

        }

        // OpeningHours Screen
        if (!serviceSettingsScreen && (target.name === 'openHour' || target.name === 'closeHour' || target.name === 'openMinute' || target.name === 'closeMinute')) {
            let updatedRestaurantOpeningHours = [];

            openingHours.map((item) => {
                const currentOpeningHours = {
                    id: item.id,
                    day: item.day,
                    openHour: item.openHour,
                    openMinute: item.openMinute,
                    closeHour: item.closeHour,
                    closeMinute: item.closeMinute,
                };

                // If value of the time field is less than 9 and there is no 0 in front of it appended 0
                let hasZero = /^0/.test(target.value);
                let hasCharacters = /\W+/.test(target.value);

                // console.log('currentOpeningHours',currentOpeningHours);

                if (!currentOpeningHours.id) {  // Menu availability hours when menuId === -1 dont have IDs
                    if (itemDay == item.day) {
                        if (target.value >= 0 && target.value <= 9 && target.value !== '' && !hasZero) {
                            currentOpeningHours[target.name] = '0' + target.value;
                        }

                        if (hasCharacters) {
                            currentOpeningHours[target.name] = target.value;
                        }
                    }
                } else if (currentOpeningHours.id === itemId) {
                    if (target.value >= 0 && target.value <= 9 && target.value !== '' && !hasZero) {
                        currentOpeningHours[target.name] = '0' + target.value;
                    }

                    if (hasCharacters) {
                        currentOpeningHours[target.name] = target.value;
                    }
                }

                updatedRestaurantOpeningHours.push(currentOpeningHours);
            });

            // console.log('updatedRestaurantOpeningHours',updatedRestaurantOpeningHours);

            return updatedRestaurantOpeningHours;
        }
    }

    static formatOpeningHours(openingHours) {
        const newOpeningHours = [];

        openingHours.map((item) => {
            let currentOpeningHours = {
                id: item.id,
                day: item.day,
                openHour: item.openHour,
                openMinute: item.openMinute,
                closeHour: item.closeHour,
                closeMinute: item.closeMinute
            };

            currentOpeningHours = this.addLeadingZeroOnCondition(currentOpeningHours, item);

            newOpeningHours.push(currentOpeningHours);

        });

        return newOpeningHours;
    }

    static formatCutOffTimes(cutOffTimes) {
        const newCutOffTimes = [];

        cutOffTimes.map((item) => {
            let currentCutOffTime = {
                day: item.day,
                hour: item.hour,
                minute: item.minute
            };

            currentCutOffTime = this.addLeadingZeroOnCondition(currentCutOffTime, item);

            newCutOffTimes.push(currentCutOffTime);

        });

        return newCutOffTimes;
    }

    static addLeadingZeroOnCondition(fieldName, item) {

        // If the number is smaller than 9 add leading zero
        let hasZero = /^[0][0-9]/;

        // Open Hours check
        if (fieldName.openHour >= 0 && fieldName.openHour <= 9 && !hasZero.test(fieldName.openHour) && fieldName.openHour !== null) {
            fieldName.openHour = '0' + item.openHour;
        }

        if (fieldName.openMinute >= 0 && fieldName.openMinute <= 9 && !hasZero.test(fieldName.openMinute) && fieldName.openMinute !== null) {
            fieldName.openMinute = '0' + item.openMinute;
        }

        if (fieldName.closeHour >= 0 && fieldName.closeHour <= 9 && !hasZero.test(fieldName.closeHour) && fieldName.closeHour !== null) {
            fieldName.closeHour = '0' + item.closeHour;
        }

        if (fieldName.closeMinute >= 0 && fieldName.closeMinute <= 9 && !hasZero.test(fieldName.closeMinute) && fieldName.closeMinute !== null) {
            fieldName.closeMinute = '0' + item.closeMinute;
        }

        // CutOffTimes check
        if (fieldName.hour >= 0 && fieldName.hour <= 9 && !hasZero.test(fieldName.hour) && fieldName.hour !== null) {
            fieldName.hour = '0' + item.hour;
        }

        if (fieldName.minute >= 0 && fieldName.minute <= 9 && !hasZero.test(fieldName.minute) && fieldName.minute !== null) {
            fieldName.minute = '0' + item.minute;
        }

        return fieldName;

    }

}

export default TimeValidationUtils;


// WEBPACK FOOTER //
// ./src/utils/TimeValidationUtils.js